import React from 'react';
import {FormattedMessage} from "react-intl";
import {useFormikContext} from "formik";

import SelectTitle from "components/radioGroup/SelectTitle";
import RadioGroup from "components/radioGroup/RadioGroup";
import FormControlLabel from "components/radioGroup/FormControlLabel";

import {Carriers} from "utils/ShippingMethods";

// no carrier: click & collect, drive, or a merchant delivering itself
const NO_CARRIER = '';

function CarrierField(props) {
    const {values, setFieldValue, setFieldTouched} = useFormikContext();

    return (
        <>
            <SelectTitle titleTranslationKey={'shippingMethods.form.field.carrier.label'} />
            <RadioGroup
                alignListWithButton
                placeholder={<FormattedMessage id={'shippingMethods.form.field.carrier.placeholder'}/>}
                selectedValueLabel={values.carrier ? <FormattedMessage id={`shippingMethods.carrier.${values.carrier}`}/> : ''}
                name={'carrier'}
                value={values.carrier ?? NO_CARRIER}
                onClickAway={() => setFieldTouched('carrier')}
                onChange={(event, value) => {
                    setFieldValue('carrier', value === NO_CARRIER ? null : value);
                }}
            >
                <FormControlLabel
                    value={NO_CARRIER}
                    label={<FormattedMessage id={'shippingMethods.form.field.carrier.none'}/>}
                />
                {Carriers.toArray().map(carrier => (
                    <FormControlLabel
                        key={carrier}
                        value={carrier}
                        label={<FormattedMessage id={`shippingMethods.carrier.${carrier}`}/>}
                    />
                ))}
            </RadioGroup>
        </>
    );
}

export default CarrierField;
